import * as yup from 'yup';
import { validateDocument, validateCnpj } from 'helpers/validations';

export const validations = yup.object().shape({
  documentId: yup
    .string()
    .required('O CNPJ ou CPF é obrigatório')
    .nullable()
    .test('documentId', 'O CPF/CNPJ precisa ser válido', value => {
      let result = true;

      if (!value || value.length === 0) {
        result = true;
      } else if (value.length === 14) {
        result = validateDocument(value);
      } else {
        result = validateCnpj(value);
      }

      return result;
    }),
  companyName: yup
    .string()
    .required('O nome ou razão social é obrigatório')
    .nullable(),
  fantasyName: yup
    .string()
    .required('O nome fantasia é obrigatório')
    .nullable(),
  phone: yup
    .string()
    .required('O telefone é obrigatório')
    .nullable(),
  email: yup
    .string()
    .email('O e-mail precisa ser válido')
    .required('O e-mail é obrigatório')
    .nullable(),
  postalCode: yup
    .string()
    .required('O CEP é obrigatório')
    .nullable(),
  address: yup
    .string()
    .required('O endereço é obrigatório')
    .nullable(),
  addressNumber: yup
    .string()
    .required('O número é obrigatório')
    .nullable(),
  district: yup
    .string()
    .required('O bairro é obrigatório')
    .nullable(),
  city: yup
    .string()
    .required('A cidade é obrigatória')
    .nullable(),
  state: yup
    .string()
    .required('O estado é obrigatório')
    .nullable(),
  planId: yup
    .string()
    .required('A seleção de plano é obrigatória')
    .nullable(),
  paymentMethodId: yup
    .string()
    .required('A forma de pagamento é obrigatória')
    .nullable(),
  installments: yup
    .string()
    .required('O número de parcelas é obrigatório')
    .nullable()
});